import axios from "axios";
import Util from '../utils/Util';
import authUtil from "../utils/AuthUtils";
import notify from "../utils/notifier";
import { getServiceApiKey } from '../utils/apiKey';

const BASE_API_URL = `${window?.appConfig?.API_ENDPOINT}`;

// Helper function to create config
const getConfig = async () => {
  const token = await authUtil.getDocumentServiceToken();
  return {
    headers: {
      "x-api-key": getServiceApiKey(),
      "x-document-service-integration-token": token,
    },
  };
};

async function uploadTemplate(requestObj) {
  const config = await getConfig();  // Await the token asynchronously
  return axios.post(BASE_API_URL + `/templates`, 
    requestObj, 
    {
      headers: {
        ...config.headers,
        "Content-Type": "multipart/form-data",
      },
  });
}

async function updateTemplate(templateId, requestObj) {
  const config = await getConfig();  // Await the token asynchronously
  return axios.put(
    BASE_API_URL + `/templates/` + templateId,
    requestObj,
    {
      headers: {
        ...config.headers,
        "Content-Type": "multipart/form-data",
      },
    }
  );
}

async function getAllTemplates(query) {
  const config = await getConfig();  // Await the token asynchronously
  let queryParams = Util.buildQueryParams(query);
  return axios.get(BASE_API_URL + `/templates` + queryParams, config);
}

async function downloadTemplate(templateId) {
  const config = await getConfig();  // Await the token asynchronously
  return axios.get(
    BASE_API_URL + `/templates/` + templateId + `/download`,
    {
      headers: {
        ...config.headers,
        "accept": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      },
      responseType: 'blob',
    }
  );
}

async function deleteTemplate(templateId) {
  const config = await getConfig();  // Await the token asynchronously
  return axios.delete(BASE_API_URL + `/templates/` + templateId, config);
}

async function generateTemplate(templateId, requestObj, vendorName = "") {
  const config = await getConfig();  // Await the token asynchronously
  
  config.headers["X-Api-Version"] = 'v2';
  
  // Add X-Vendor-Name header if vendor is selected
  if (vendorName) {
    config.headers["X-Vendor-Name"] = vendorName;
  }
  
  return axios.post(
    BASE_API_URL + "/templates/" + templateId + "/document",
    requestObj,
    {
      headers: {
        ...config.headers
      },
      responseType: 'blob',
    }
  );
}

export default {
  uploadTemplate,
  updateTemplate,
  getAllTemplates,
  downloadTemplate,
  deleteTemplate,
  generateTemplate,
};
